import React, { FC } from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgDialog } from "@intelligems/ig-theme";

import { useGetOrg } from "../../api/organizations/get-organization";
import { useRefreshShopifyScopes } from "../../api/user-auths/login";
import { snoozeShopifyScopesDialog } from "../../store/slices/appSettings";
import {
  getDialog,
  IGlobalState,
  isDialogOpen,
  setDialog,
} from "../../store/slices/global";
import { IAppState } from "../../store/types/store";

export const MissingShopifyScopeDialog: FC = () => {
  const dispatch = useDispatch();
  const snoozedShopifyScopesDialog = useSelector(
    (state: IAppState) => state.appSettings.snoozeShopifyScopesDialog
  );
  const dialog = useSelector(
    getDialog("missingShopifyScope")
  ) as IGlobalState["dialogs"]["missingShopifyScope"];

  // New users may see both of these, hide the shopify scope dialog if onboarding is also open
  const isOnboardingDialogOpen = useSelector(isDialogOpen("onboarding"));

  const isOpen = dialog.isOpen && !isOnboardingDialogOpen;

  useGetOrg({
    refetchOnMount: isOpen ? "always" : undefined,
    refetchOnWindowFocus: isOpen ? "always" : undefined,
  });

  const refreshShopifyCredentials = useRefreshShopifyScopes();

  const handleClose = (event: any, reason: any) => {
    if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
      if (!snoozedShopifyScopesDialog) {
        dispatch(snoozeShopifyScopesDialog());
      }
      dispatch(setDialog({ dialog: "missingShopifyScope", open: false }));
    }
  };
  const handleYesClick = () => {
    refreshShopifyCredentials.mutate({});
  };

  return (
    <IgDialog
      handleClose={handleClose}
      content={
        dialog.props?.initial
          ? "Please reauthorize your store to access all latest features."
          : "This feature requires additional permissions from Shopify. Please reauthorize your store to continue."
      }
      shouldNotClose={true}
      loading={refreshShopifyCredentials.isPending}
      handleYesClick={handleYesClick}
      yesButtonText={"Update Permissions"}
      noButtonText={"Update Later"}
      title={"Update Shopify Permissions"}
      showDialog={isOpen}
      dialogHeight={null}
      hideActions={false}
    />
  );
};
